<img [src]="getSantizeUrl(base64Image)" style="height:100%;"/>
